// extracted by mini-css-extract-plugin
export default {"wrapper":"EditorPage_wrapper__97k1p","faqButton":"EditorPage_faqButton__kzwUz"};